import React, { useEffect,useState } from "react";
import moment from "moment";
import OrgPrintCertificateComponent from "./OrgPrintCertificateComponent"



const OrgPrintCertificate: React.FC = () => {
  const [orgRegNumber, setOrgRegNumber] = useState<any>();
  const [orgName, setOrgName] = useState<any>();
  const [orgDate, setOrgDate] = useState<any>();
  const [orgExpDate, setOrgExpDate] = useState<any>();


useEffect(() => {
       const orgData =  localStorage.getItem("orgdata");
              if (orgData) {
                  const retrievedObject = JSON.parse(orgData);
                  // Avoid logging sensitive org details
                 setOrgName(retrievedObject.organizationName);
                 const apprDate = moment(retrievedObject.approvalDate);
                 const apprDateStr = moment(retrievedObject.approvalDate).format('DD-MM-YYYY');
                 const VALIDITY_YEARS = 5;
                 const futureDate = apprDate.clone().add(VALIDITY_YEARS, 'years');

                  setOrgDate(apprDateStr);
                  setOrgExpDate(moment(futureDate).format('DD-MM-YYYY'));
                  setOrgRegNumber(retrievedObject.tgmcRegNumber);
              }
    }, []);
  return (
   <>
   <OrgPrintCertificateComponent 
   orgName={orgName}
   orgRegNumber={orgRegNumber}
   orgDate={orgDate}
   orgExpDate={orgExpDate}
    />
   </>
    
  
  );
};

export default OrgPrintCertificate;
